
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function VaricoseVein(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Varicose Vein"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Varicose veins are twisted, enlarged veins. Any superficial vein may
                                    become varicosed, but the veins most commonly affected are those in
                                    your legs. That's because standing and walking upright increases the
                                    pressure in the veins of your lower body.
                                </p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Varicose-vein/1.png")} alt="Varicose-vein" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <ul className="listUnstyle">
                                    <li>
                                        <p>
                                            <b>Varicose veins may not cause any pain. Signs you may have varicose veins include: </b>
                                            <br />
                                            Veins that are dark purple or blue in color, Veins that appear twisted and bulging; they are often like cords on your legs
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>When painful signs and symptoms occur, they may include: </b>
                                            <br />
                                            An achy or heavy feeling in your legs,Burning, throbbing, muscle cramping and swelling in your lower legs,Worsened pain after sitting or standing for a long time,Itching around one or more of your veins,Skin discoloration around a varicose vein
                                        </p>
                                    </li>
                                </ul>
                                <p>Spider veins are similar to varicose veins, but they're smaller. Spider veins are found closer to the skin's
                                    surface and are often red or blue.</p>
                                <p>Spider veins occur on the legs, but can also be found on the face. They vary in size and often look like a
                                    spider's web.</p>

                                <a className="links" href="https://en.wikipedia.org/wiki/Varicose_veins">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default VaricoseVein;